import useResource from "hooks/resources"
import { get } from "lodash"

const EMPTY_ARRAY = []

export const BASKETS_QUERY = {
  resource: "baskets",
  url: () => ({
    id: "baskets",
    query: "query { baskets: swaps { ticker, description, availableFrom, terminationDate, currencyOverride, lastUpdated } }",
  }),
}

export function useBaskets() {
  return useResource(BASKETS_QUERY, "baskets")
}

export function getBaskets(state) {
  return get(state, "global.data.baskets.data.baskets", EMPTY_ARRAY)
}
